import _ from "lodash";

const TableBody = ({ data, columns, isLoading }) => {
  const renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  return (
    <tbody>
      {isLoading && (
        <tr className="bg-gray-50">
          <td
            className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-center"
            colSpan={columns.length}
          >
            Loading...
          </td>
        </tr>
      )}
      {!isLoading && data.length === 0 && (
        <tr className="bg-gray-50">
          <td
            className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-center"
            colSpan={columns.length}
          >
            No data available
          </td>
        </tr>
      )}
      {!isLoading &&
        data.length > 0 &&
        data.map((item) => (
          <tr key={item.id} className="hover:bg-gray-50">
            {columns.map((column) => (
              <td
                key={createKey(item, column)}
                className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-left"
              >
                {renderCell(item, column)}
              </td>
            ))}
          </tr>
        ))}
    </tbody>
  );
};

export default TableBody;
